import React, { ReactNode, Suspense } from "react";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "../Icons/LoadingSpinner";
import { paths } from "./paths";
import { ROLE } from "../utils/constant";


// Organization
const Designation = React.lazy(() => import('../pages/Dashboard/Organization/Designation/list'));
const Departments = React.lazy(() => import('../pages/Dashboard/Organization/department/list'));
const Shift = React.lazy(() => import('../pages/Dashboard/Organization/shift/list'));
const ShiftHistory = React.lazy(() => import("../section/organization/shift/shifthistory/view"));
const HolidayList = React.lazy(() => import("../pages/Dashboard/Organization/holiday/list"));


// Leave-Tracker
const MyLeaves = React.lazy(() => import('../pages/Dashboard/LeaveTracker/leaves/list'));
const ApplySelfLeaves = React.lazy(() => import('../pages/Dashboard/LeaveTracker/leaves/new-self'));
const LeaveBalance = React.lazy(() => import('../pages/Dashboard/LeaveTracker/leaves/balance'));

// Employee-tracker
const Employee = React.lazy(() => import('../pages/Dashboard/Organization/Employee'));
const AddExist = React.lazy(() => import("../pages/Dashboard/Employee/AddExist"));
const ProfileEmployee = React.lazy(() => import("../pages/Dashboard/Employee/Profile"));
const AddEmployeeForm = React.lazy(() => import('../pages/Dashboard/Employee/AddEmployee'));
const EditEmployee = React.lazy(() => import("../pages/Dashboard/Employee/EditEmployee"));


// Attendance
const DailyDevice = React.lazy(() => import('../pages/Dashboard/attendance/daily-device-list'));
const MonthlyDevice = React.lazy(() => import('../pages/Dashboard/attendance/monthly-device-list'));
const Attendance = React.lazy(() => import('../pages/Dashboard/attendance/list'));

// Jobs
const JobList = React.lazy(() => import('../pages/Dashboard/jobs/list'));
const ApplicantList = React.lazy(() => import("../pages/Dashboard/Applicant/ApplicantList"));

// Feedback
const FeedBackListPage = React.lazy(() => import('../pages/feedback/list'));

const AgreementListPage = React.lazy(() => import('../pages/agreements/page'));

// Students
const StudentCreatePage = React.lazy(() => import('../pages/trainings/student/new'));
const StudentProfilePage = React.lazy(() => import('../pages/trainings/student/profile'));
const StudentListPage = React.lazy(() => import('../pages/trainings/student/list'));
const StudentEditPage = React.lazy(() => import('../pages/trainings/student/edit'));

// Training
const TrainingListPage = React.lazy(() => import('../pages/trainings/trainers/list'));

// Training

const PaymentsListPage = React.lazy(() => import('../pages/trainings/trainers/list'));

const CounsellorsListPage = React.lazy(() => import('../pages/trainings/counselors/page'));

const ProgramListPage = React.lazy(() => import('../pages/trainings/program/list'));

const ClassesListPage = React.lazy(() => import('../pages/trainings/classes/page'));

const TrainingDahboardPage = React.lazy(() => import('../pages/trainings/dashboard/page'));

const FeeManagementListPage = React.lazy(() => import('../pages/trainings/fee-management/list'));












const ProtectedAdminHRRoute: React.FC<{ children: ReactNode }> = ({ children }) => {
    const isAdmin = localStorage.getItem('roleName');
    return (isAdmin === 'Admin' || isAdmin === 'HR') ? (
        <> {children} </>
    ) : (
        <Navigate to="/dashboard" />
    );
};


const renderProtectedHRRoute = (Component: React.ComponentType<any>, props?: any) => (
    <Suspense fallback={<LoadingSpinner className="mr-2 h-full w-14 animate-spin" />}>
        <ProtectedAdminHRRoute>
            <Component {...props} />
        </ProtectedAdminHRRoute>
    </Suspense>
);

const { trainings } = paths

export const HrRoutes = [
    {
        path: "/dashboard/jobs/applicants",
        element: renderProtectedHRRoute(ApplicantList),
        title: "Applicants",
        role: ['admin', 'employee'],
    },

    {
        path: "/dashboard/jobs/list",
        element: renderProtectedHRRoute(JobList),
        title: "Applicants",
        role: ['admin', 'employee'],
    },
    {
        path: "/dashboard/organization/employee/profile/:empId",
        element: renderProtectedHRRoute(ProfileEmployee),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/employee/add-exit",
        element: renderProtectedHRRoute(AddExist),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/employee/add-employee",
        element: renderProtectedHRRoute(AddEmployeeForm, { title: 'Add' }),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/employee/profile/edit",
        element: renderProtectedHRRoute(EditEmployee),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/employee/profile/edit/:empId",
        element: renderProtectedHRRoute(EditEmployee),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/leave-balance",
        element: renderProtectedHRRoute(LeaveBalance),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/designation",
        element: renderProtectedHRRoute(Designation),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/department",
        element: renderProtectedHRRoute(Departments),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/shift",
        element: renderProtectedHRRoute(Shift),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/shift-history",
        element: renderProtectedHRRoute(ShiftHistory),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/holiday-list",
        element: renderProtectedHRRoute(HolidayList),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/shift-add",
        element: renderProtectedHRRoute(Shift),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/organization/employee",
        element: renderProtectedHRRoute(Employee),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/attendance/daily-device",
        element: renderProtectedHRRoute(DailyDevice),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/attendance/monthly-device",
        element: renderProtectedHRRoute(MonthlyDevice),
        title: "Dashboard",
        role: ['admin', 'employee'],
    },
    {
        path: "/dashboard/organization/attendance",
        element: renderProtectedHRRoute(Attendance),
        title: "Attendance",
        role: ['admin'],
    },
    {
        path: "/dashboard/attendance/daily",
        element: renderProtectedHRRoute(() => <>Work - in progress</>),
        title: "Dashboard",
        role: ['admin'],
    },

    {
        path: "/dashboard/my-leaves",
        element: renderProtectedHRRoute(MyLeaves),
        title: "Dashboard",
        role: ['admin'],
    },
    {
        path: "/dashboard/my-leaves/add-leave",
        element: renderProtectedHRRoute(ApplySelfLeaves),
        title: "Dashboard",
        role: ['HR'],
    },
    {
        path: "/dashboard/feedback/employee-list",
        element: renderProtectedHRRoute(FeedBackListPage),
        title: "Calendar",
        role: ['admin', 'Manager'],
    },
    {
        path: "/aggreement-list",
        element: renderProtectedHRRoute(AgreementListPage),
        title: "Applicants",
        role: ROLE.ALLOWED_HR_DEPT,
    },
    {
        path: trainings.students,
        element: renderProtectedHRRoute(StudentListPage),
        title: "Student List",
        role: ROLE.ALLOWED_HR_DEPT,
    },
    {
        path: trainings.studentsNew,
        element: renderProtectedHRRoute(StudentCreatePage),
        title: "Student New",
        role: ROLE.ALLOWED_HR_DEPT,
    },
    {
        path: trainings.student.profile,
        element: renderProtectedHRRoute(StudentProfilePage),
        title: "Student New",
        role: ROLE.ALLOWED_HR_DEPT,
    },
    {
        path: "/students/edit/:id",
        element: renderProtectedHRRoute(StudentEditPage),
        title: "Student Edit",
        role: ROLE.ALLOWED_HR_DEPT,
    },

    // Trainings

];